import type { LucideIcon } from 'lucide-react';
import { Info, CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

export const logIcons: Record<string, LucideIcon> = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  error: XCircle,
};

export const logColors: Record<string, string> = {
  info: 'text-blue-500 dark:text-blue-400',
  success: 'text-emerald-500 dark:text-emerald-400',
  warning: 'text-amber-500 dark:text-amber-400',
  error: 'text-rose-500 dark:text-rose-400',
};

